import { NgModule } from '@angular/core';
import { HasPermissionPipe } from './has-permission.pipe';
import { FilterMenuByPermissionsPipe } from './filter-menu-by-permissions.pipe';
import { I18nLabelPipe } from './i18n-label.pipe';
import { FilterTypeLabelPipe } from './filter-type-label.pipe';

@NgModule({
  declarations: [
    HasPermissionPipe,
    FilterMenuByPermissionsPipe,
    I18nLabelPipe,
    FilterTypeLabelPipe
  ],
  exports: [
    HasPermissionPipe,
    FilterMenuByPermissionsPipe,
    I18nLabelPipe,
    FilterTypeLabelPipe
  ]
})
export class PipesModule { }